<!-- Skip Links para Acessibilidade -->
<nav aria-label="Links de atalho">
 <a class="skip-link" [routerLink]="[]" fragment="main-content">
  Pular para conteúdo principal
</a>
 <a class="skip-link" [routerLink]="[]" fragment="main-navigation">
  Pular para navegação
</a>
</nav>
<!-- PROGRESS BAR -->
<cdk-progress-bar></cdk-progress-bar>
<!-- / PROGRESS BAR -->

<!-- PROTOCOLO STANDALONE -->
@if (isProtocoloRoute) {
  <main id="main-content" tabindex="-1">
    <router-outlet></router-outlet>
  </main>
} @else {
  <!-- GOOGLE CHATBOT -->
  <chat-bot></chat-bot>
  <!-- / GOOGLE CHATBOT -->
  <!-- VERTICAL LAYOUT 1 -->
  @if (cdkConfig.layout.style === 'vertical-layout-1') {
    <vertical-layout-1></vertical-layout-1>
  }
  <!-- / VERTICAL LAYOUT 1 -->

  <!-- VERTICAL LAYOUT 2 -->
  @if (cdkConfig.layout.style === 'vertical-layout-2') {
    <vertical-layout-2></vertical-layout-2>
  }
  <!-- / VERTICAL LAYOUT 2 -->

  <!-- VERTICAL LAYOUT 3 -->
  @if (cdkConfig.layout.style === 'vertical-layout-3') {
    <vertical-layout-3></vertical-layout-3>
  }
  <!-- / VERTICAL LAYOUT 3 -->

  <!-- HORIZONTAL LAYOUT 1 -->
  @if (cdkConfig.layout.style === 'horizontal-layout-1') {
    <horizontal-layout-1></horizontal-layout-1>
  }
  <!-- / HORIZONTAL LAYOUT 1 -->

  <cdk-sidebar name="themeOptionsPanel" class="theme-options-sidebar" position="right" [invisibleOverlay]="true">
    <cdk-theme-options></cdk-theme-options>
  </cdk-sidebar>
  <!-- / THEME OPTIONS PANEL -->

  <p-confirmDialog
    header="Confirmação"
    closable="false"

    acceptLabel="Sim"  
    acceptIcon="pi pi-check"
    acceptButtonStyleClass="bg-primary border-primary hover:bg-primary-dark text-white p-button-raised"

    rejectLabel="Não"
    rejectIcon="pi pi-times"
    rejectButtonStyleClass="text-primary p-button-text hover:bg-primary-100 dark:hover:bg-primary-900/20"
  ></p-confirmDialog>
}
